import React from 'react';
import Item from './Item';

const navList = [
  {
    name: 'header_menu_users',
    permissions: ['USERS_LIST', 'GROUPS_LIST'],
    children: [
      { name: 'header_menu_users', url: '/users/users', permissions: ['USERS_LIST'] },
      { name: 'header_menu_groups', url: '/users/groups', permissions: ['GROUPS_LIST'] },
    ],
  },
  {
    name: 'header_menu_trainings',
    permissions: ['SERIES_LIST', 'TRAININGS_LIST'],
    children: [
      { name: 'header_menu_series', url: '/series', permissions: ['SERIES_LIST'] },
      { name: 'header_menu_trainings', url: '/trainings', permissions: ['TRAININGS_LIST'] },
    ],
  },
  {
    name: 'header_menu_reports',
    permissions: ['USER_REPORTS', 'TRAINING_REPORTS'],
    children: [
      { name: 'header_menu_userReports', url: '/reports/users', permissions: ['USER_REPORTS'] },
      { name: 'header_menu_trainingReports', url: '/reports/trainings', permissions: ['TRAINING_REPORTS'] },
    ],
  },
  {
    name: 'header_menu_company',
    permissions: ['COMPANY_CONFIG_GET', 'COMPANY_CONFIG_EDIT_SAVE'],
    children: [
      {
        name: 'header_menu_companyConfiguration',
        url: '/config',
        permissions: ['COMPANY_CONFIG_GET', 'COMPANY_CONFIG_EDIT_SAVE'],
      },
      {
        name: 'header_menu_companyOptions',
        url: '/options',
        permissions: ['COMPANY_CONFIG_GET', 'COMPANY_CONFIG_EDIT_SAVE'],
      },
    ],
  },
];

export default ({ user }) => (
  <React.Fragment>{navList.map(({ name, permissions, children }) => (
    user.permissions.includes(permissions[0]) || user.permissions.includes(permissions[1])
      ? <Item key={name} user={user} name={name} permissions={permissions} children={children} />
      : null))}
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdownCompany/index.js